import hcAxios, { RequestOptions } from 'core/utils/hcAxios'
import { TResponse } from 'core/service/hcResponse'
// 福利中心
enum API {
  /** 我的奖励列表 @admin */
  RewardMyRewardsList = '/hk-web/reward/myRewards/list',
  /** 我的任务列表 @admin */
  RewardMyTasksList = '/hk-web/reward/myTasks/list',
  /** 领取任务 @admin */
  RewardTaskReceive = '/hk-web/reward/task/receive',
  /** 限时活动列表 @admin */
  RewardTlimitedActivityList = '/hk-web/reward/tlimitedActivity/list',
  /** 理财体验金相关 @Frank */
  RewardTrialInterface = '/hk-web/reward/trial/interface',
  /** 任务列表 @Peter */
  RewardTasksList = '/hk-web/reward/tasks/list',
  /** 我的奖励使用(或领取，如果卡券需要领取则表示领取[领取是receivePeriod字段大于0]) @Frank */
  RewardMyRewardsUse = '/hk-web/reward/myRewards/use',
  /** 用户已完成任务累计奖励 @admin */
  RewardMytasksAmount = '/hk-web/reward/mytasks/amount',
  /** 随机获已领取奖励的用户列表 @admin */
  RewardRandomCompletedtasks = '/hk-web/reward/random/completedtasks',
  /** 生效任务、新手任务累计奖励 @admin */
  RewardTasksAmount = '/hk-web/reward/tasks/amount',
  /** 任务详情 @cory */
  RewardTasksDetail = '/hk-web/reward/tasks/detail',
  /** 合约卡券图标状态 @admin */
  RewardFutureCardStatus = '/hk-web/reward/future-card-status',
  /** 生效任务、新手任务累计奖励 @ryan */
  V1RewardTasksAmount = '/hk-web/v1/reward/tasks/amount',
  /** 福利中心每日任务 @admin */
  RewardDailyTasks = '/hk-web/reward/daily/tasks',
  /** 福利中心新人交易挑战任务 @admin */
  RewardDpttradeTasks = '/hk-web/reward/dpttrade/tasks',
  /** 我的任务记录 @admin */
  RewardMyTasksRecord = '/hk-web/reward/myTasks/record',
  /** 领取奖励 @Frank */
  RewardReceiveMyReward = '/hk-web/reward/receiveMyReward',
  /** 公告限时活动报名提交 @Peter */
  RewardActivityApply = '/hk-web/reward/activity/apply',
  /** 发放新人交易挑战卡券 @ryan */
  RewardDpttradeReleaseCard = '/hk-web/reward/dpttrade/releaseCard',
  /** 福利中心banner配置 @Peter */
  RewardBannerActivityList = '/hk-web/reward/bannerActivity/list',
  /** 福利中心专属任务 @Peter */
  RewardExclusiveTasks = '/hk-web/reward/exclusive/tasks',
  /** 福利中心活动参数配置 @Frank */
  RewardActivityParams = '/hk-web/reward/activity/params',
  /** 判断用户是否代理商或旗下 @Peter */
  RewardExistAgentUser = '/hk-web/reward/existAgentUser',
  /** 限时首充活动报名状态 @Frank */
  RewardActivityFirstDepositStatus = '/hk-web/reward/activity/first-deposit/status',
  /** 限时首充活动报名提交 @Frank */
  RewardActivityFirstDepositApply = '/hk-web/reward/activity/first-deposit/apply',
  /** 限时首充活动事件配置 @Frank */
  RewardActivityFirstDepositEvent = '/hk-web/reward/activity/first-deposit/event',
  /** 限时首充活动领取提交 @Frank */
  RewardActivityFirstDepositReceive = '/hk-web/reward/activity/first-deposit/receive',
}

/** 卡券状态 */
export enum RewardCardStatus {
  /** 未使用 */
  UNUSED = 0,
  /** 使用中 */
  IN_USE = 1,
  /** 已使用 */
  USED = 2,
  /** 已过期 */
  EXPIRED = 3,
  /** 已回收 */
  RECYCLED = 4,
}

/** 查询场景 */
export enum RewardQueryScene {
  /** 我的卡券 */
  MY_CARD = 1,
  /** 合约卡券 */
  CONTRACT_CARD = 2,
  /** 合约体验金 */
  CONTRACT_EXPERIENCE = 3,
  /** 合约手续费抵扣券 */
  CONTRACT_FEE_DEDUCTION = 4,
}

export enum InstType {
  SPOT = 2, // 现货
  SPOT_MARGIN = 3, // 现货杠杆
  PERPETUAL = 4, // 永续合约
  DELIVERY = 5, // 交割合约
  OPTION = 6, // 期权
}

/** 卡券类型 */
export enum RewardCardType {
  /** 合约体验金 */
  CONTRACT_EXPERIENCE = 1,
  /** 合约固定额度手续费抵扣券 */
  CONTRACT_FIXED_FEE_DEDUCTION = 2,
  /** 合约固定比例手续费抵扣券 */
  CONTRACT_RATIO_FEE_DEDUCTION = 3,
  /** 理财体验金 */
  FINANCIAL_EXPERIENCE = 4,
  /** 合约无门槛体验金 */
  CONTRACT_NO_THRESHOLD_EXPERIENCE = 5,
  /** 合约赠金 */
  CONTRACT_BONUS = 6,
  /** 交易基金 */
  CONTRACT_FUND_CARD = 7,
  /** 合约开仓券 */
  CONTRACT_OPEN_COUPON = 8,
}

export type TGetRewardMyRewardsListParams = {
  /** 福利中心版本 1-2023版本 2-202409版本 3-202503版本 */
  bver?: any
  /** 卡券状态：0-未使用/1-使用中/2-已使用/3-已过期 */
  cardStatus?: any
  /** 卡券类型列表：1-合约体验金/2-合约固定额度手续费抵扣券/3-合约固定比例手续费抵扣券/4-理财体验金/5-合约无门槛体验金/6-合约赠金/7-合约交易基金/8-合约开仓券 */
  cardTypeList?: any
  /** 排序的列字段 添加该字段后必须加排序 */
  columnSort?: any
  /** 是否返回总记录数，默认true */
  count?: any
  /** 页码 */
  pageNum?: any
  /** 每页显示条数 */
  pageSize?: any
  /** 查询场景 1我的卡券 2合约卡券 3合约体验金 4合约手续费抵扣券 */
  scene?: any
}
export type TGetRewardMyRewardsListResponse = TResponse<
  {
    /** 余额：目前就赠金用 */
    balance?: string
    /** 来源 */
    cardSourceName?: string
    /** 卡券状态：0-未使用/1-使用中/2-已使用/3-已过期/4-已回收 */
    cardStatus?: number
    /** 卡券类型：1-合约体验金/2-合约固定额度手续费抵扣券/3-合约固定比例手续费抵扣券/4-理财体验金/5-合约无门槛体验金/6-合约赠金/7-合约交易基金/8-合约开仓券 */
    cardType?: number
    /** 关联计划订单ID */
    conditionOrderId?: number
    /** 支持合约币对 */
    contractCode?: string
    /** 合约交易对编码别名 例如：ETH/USDT */
    contractCodeAlias?: string
    /** 合约类型 perpetual-永续 week-当周 nextWeek-次周 quarter-当季 nextQuarter-次季 */
    contractType?: string
    /** 面额 */
    denomination?: string
    /** 卡券生效时间 */
    effectiveTime?: number
    /** 卡券过期时间 */
    expireTime?: number
    /** 交易基金userid */
    fundId?: number
    /** 支持的合约类型：0：所有；1：永续；2：交割。目前合约赠金使用 */
    futureType?: number
    /** 体验金限制持仓时间(天) */
    holdingDays?: number
    /** id */
    id?: number
    /** 产品类型 2-现货 3-现货杠杆 4-永续合约 5-交割合约 6-期权 */
    instType?: number
    /** 领取赠金的KYC要求：0：无要求；1：所有用户；2：存在关联账号的用户。目前合约赠金使用 */
    kycAuthType?: number
    /** 最大支持杠杆 */
    maxMarginRatio?: number
    /** 关联订单ID */
    orderId?: number
    /** 卡券失效时间 */
    overdueTime?: number
    /** 盈利比例：目前就交易基金用 */
    profitRatio?: number
    /** 比例：如折扣比例10%，返回10 */
    proportion?: string
    /** 卡券领取过期时间 */
    receiveExpireTime?: number
    /** 领取有效期：单位：天。目前合约赠金使用(合约交易基金) */
    receivePeriod?: number
    /** 卡券领取时间 */
    receiveTime?: number
    /** 备注 */
    remarks?: string
    /** 止损：目前就交易基金用 */
    stopLoss?: number
    /** 止盈：目前就交易基金用 */
    stopProfit?: number
    /** 卡券有效期：单位：天 */
    validityPeriod?: number
  }[]
>
export const getRewardMyRewardsList = (params?: TGetRewardMyRewardsListParams, options?: RequestOptions) => {
  return hcAxios.get<TGetRewardMyRewardsListResponse>(API.RewardMyRewardsList, { params, options })
}

export type TGetRewardMyTasksListParams = {
  /** 是否返回总记录数，默认true */
  count?: any
  /** 结束时间戳 */
  endTime?: any
  /** 页码 */
  pageNum?: any
  /** 每页显示条数 */
  pageSize?: any
  /** 开始时间戳 */
  startTime?: any
  /** 任务状态：1-进行中/2-已完成/3-已过期。不传查全部类型 */
  taskStatus?: any
  /** 不传返回所有类型任务，1-新手任务/4-每日任务/6-充值交易挑战 */
  taskType?: any
}
export type TGetRewardMyTasksListResponse = TResponse<
  {
    /** 卡券类型：1-合约体验金/2-合约固定额度手续费抵扣券/3-合约固定比例手续费抵扣券/4-理财体验金/5-合约无门槛体验金 */
    cardType?: number
    /** 每日任务：1-链上充值/2-现货/3-杠杆/4-合约/5-跟单/6-理财赚币/7-净资产/8-邀请好友 */
    chlgTaskType?: number
    /** 支持合约币对 */
    contractCode?: string
    /** 合约类型 perpetual-永续 week-当周 nextWeek-次周 quarter-当季 nextQuarter-次季 */
    contractType?: string
    /** 当前交易额 */
    currentTradeAmount?: string
    /** 截止时间 */
    deadlineTime?: number
    /** 面额 */
    denomination?: string
    /** 任务失效时间 */
    expireTime?: number
    /** 我的任务id */
    id?: number
    /** 产品类型 2-现货 3-现货杠杆 4-永续合约 5-交割合约 6-期权 */
    instType?: number
    /** 比例：如折扣比例10%，返回10 */
    proportion?: string
    /** 奖励发放状态 -1-未完成任务 0-正在发放 1-已发放(系统已发放奖励，与用户是否领取无关) 2-已领取 */
    rewardGiftStatus?: number
    /** 任务id */
    rewardTaskId?: number
    /** 目标交易额 */
    targetTradeAmount?: string
    /** 任务描述 */
    taskDescriptions?: string
    /** 任务状态：1-进行中/2-已完成/3-已过期 */
    taskStatus?: number
    /** 任务标题 */
    taskTitles?: string
    /** 任务类型：1-新手任务/2-体验任务/3-交易任务/4-每日任务/5-专属任务/6-充值交易挑战 */
    taskType?: number
    /** 是否限时 0-否 1-是 */
    tlimitedFlag?: boolean
    /** 交易产品 1-永续合约 2-现货交易 3-杠杆交易 */
    tradeInst?: number
    /** 完成时间戳 */
    updatedTime?: number
    /** 任务有效期(天)/-1表示无限期 */
    validityPeriod?: number
  }[]
>
export const getRewardMyTasksList = (params?: TGetRewardMyTasksListParams, options?: RequestOptions) => {
  return hcAxios.get<TGetRewardMyTasksListResponse>(API.RewardMyTasksList, { params, options })
}

export type TPostRewardTaskReceiveParams = {
  /** 安静模式：忽略错误 */
  quiet?: boolean
  /** 任务id */
  taskId?: number
}
export type TPostRewardTaskReceiveResponse = TResponse<any>
export const postRewardTaskReceive = (params?: TPostRewardTaskReceiveParams, options?: RequestOptions) => {
  return hcAxios.post<TPostRewardTaskReceiveResponse>(API.RewardTaskReceive, params, { options })
}

export type TGetRewardTlimitedActivityListParams = {
  /** 是否返回总记录数，默认true */
  count?: any
  /** 页码 */
  pageNum?: any
  /** 每页显示条数 */
  pageSize?: any
}
export type TGetRewardTlimitedActivityListResponse = TResponse<
  {
    /** 活动状态 1-预热中 2-进行中 3-已结束 */
    activityStatus?: number
    /** 倒计时时间 */
    countDown?: number
    /** 结束时间 */
    endTime?: number
    /** 活动图片 */
    icon?: string
    /** 活动id */
    id?: number
    /** H5活动链接 */
    jumpH5?: string
    /** APP活动链接 */
    jumpLink?: string
    /** Web活动链接 */
    jumpWeb?: string
    /** 展示类型：1-所有用户/2-指定UID/3-代理商 */
    showType?: number
    /** 开始时间 */
    startTime?: number
    /** 活动标题 */
    title?: string
  }[]
>
export const getRewardTlimitedActivityList = (
  params?: TGetRewardTlimitedActivityListParams,
  options?: RequestOptions
) => {
  return hcAxios.get<TGetRewardTlimitedActivityListResponse>(API.RewardTlimitedActivityList, { params, options })
}

export type TGetRewardTrialInterfaceParams = any
export type TGetRewardTrialInterfaceResponse = TResponse<{}>
export const getRewardTrialInterface = (params?: TGetRewardTrialInterfaceParams, options?: RequestOptions) => {
  return hcAxios.get<TGetRewardTrialInterfaceResponse>(API.RewardTrialInterface, { params, options })
}

export type TGetRewardTasksListParams = {
  /** 福利中心版本 1-2023版本 2-202409版本 3-202503版本 */
  bver?: any
  /** 是否返回总记录数，默认true */
  count?: any
  /** 页码 */
  pageNum?: any
  /** 每页显示条数 */
  pageSize?: any
  /** 不传返回所有类型任务，1-新手任务/2-体验任务/3-交易任务/4-每日任务/5-专属任务/6-充值交易挑战 */
  taskType?: any
}
export type TGetRewardTasksListResponse = TResponse<{
  /** 体验任务列表 */
  experienceTasks?: {
    /** 加码截止时间，注册时间+24小时 */
    addingEndTime?: number
    /** 卡券类型：1-合约体验金/2-合约固定额度手续费抵扣券/3-合约固定比例手续费抵扣券/4-理财体验金/5-合约无门槛体验金 */
    cardType?: number
    /** 合约交易对编码别名 例如：ETH/USDT */
    contractCodeAlias?: string
    /** 面额(体验金金额) */
    denomination?: string
    /** 体验金限制持仓时间(天) */
    holdingDays?: number
    /** 任务id */
    id?: number
    /** 最大支持杠杆 */
    maxMarginRatio?: number
    /** 我的任务id */
    myTaskId?: number
    /** 比例：如折扣比例10%，返回10 */
    proportion?: string
    /** 截止时间 */
    receiveEndTime?: number
    /** 领取状态 0-未领取，1-已领取，2-条件不符 */
    receiveStatus?: number
    /** 加码金额 */
    rewardAddingAmount?: number
    /** 注册当天完成首充是否加码 0-否 1-是 */
    rewardAddingFlag?: boolean
    /** 奖励发放状态 -1-未完成任务 0-正在发放 1-已发放(系统已发放奖励，与用户是否领取无关) 2-已领取 */
    rewardGiftStatus?: number
    /** 目标类型 1-单笔 2-累计 */
    targetType?: number
    /** 任务描述 */
    taskDescriptions?: string
    /** 任务标题 */
    taskTitles?: string
    /** 任务类型：1-新手任务/2-体验任务/3-交易任务/4-每日任务/5-专属任务/6-充值交易挑战 */
    taskType?: number
    /** 交易金额 */
    tradeAmount?: string
  }[]
  /** 新手任务列表 */
  newbieTasks?: {
    /** 加码截止时间，注册时间+24小时 */
    addingEndTime?: number
    /** 卡券类型：1-合约体验金/2-合约固定额度手续费抵扣券/3-合约固定比例手续费抵扣券/4-理财体验金/5-合约无门槛体验金 */
    cardType?: number
    /** 合约交易对编码别名 例如：ETH/USDT */
    contractCodeAlias?: string
    /** 面额(体验金金额) */
    denomination?: string
    /** 体验金限制持仓时间(天) */
    holdingDays?: number
    /** 任务id */
    id?: number
    /** 最大支持杠杆 */
    maxMarginRatio?: number
    /** 我的任务id */
    myTaskId?: number
    /** 比例：如折扣比例10%，返回10 */
    proportion?: string
    /** 截止时间 */
    receiveEndTime?: number
    /** 领取状态 0-未领取，1-已领取，2-条件不符 */
    receiveStatus?: number
    /** 加码金额 */
    rewardAddingAmount?: number
    /** 注册当天完成首充是否加码 0-否 1-是 */
    rewardAddingFlag?: boolean
    /** 奖励发放状态 -1-未完成任务 0-正在发放 1-已发放(系统已发放奖励，与用户是否领取无关) 2-已领取 */
    rewardGiftStatus?: number
    /** 目标类型 1-单笔 2-累计 */
    targetType?: number
    /** 任务描述 */
    taskDescriptions?: string
    /** 任务标题 */
    taskTitles?: string
    /** 任务类型：1-新手任务/2-体验任务/3-交易任务/4-每日任务/5-专属任务/6-充值交易挑战 */
    taskType?: number
    /** 交易金额 */
    tradeAmount?: string
  }[]
  /** 交易任务列表 */
  tradeTasks?: {
    /** 加码截止时间，注册时间+24小时 */
    addingEndTime?: number
    /** 卡券类型：1-合约体验金/2-合约固定额度手续费抵扣券/3-合约固定比例手续费抵扣券/4-理财体验金/5-合约无门槛体验金 */
    cardType?: number
    /** 合约交易对编码别名 例如：ETH/USDT */
    contractCodeAlias?: string
    /** 面额(体验金金额) */
    denomination?: string
    /** 体验金限制持仓时间(天) */
    holdingDays?: number
    /** 任务id */
    id?: number
    /** 最大支持杠杆 */
    maxMarginRatio?: number
    /** 我的任务id */
    myTaskId?: number
    /** 比例：如折扣比例10%，返回10 */
    proportion?: string
    /** 截止时间 */
    receiveEndTime?: number
    /** 领取状态 0-未领取，1-已领取，2-条件不符 */
    receiveStatus?: number
    /** 加码金额 */
    rewardAddingAmount?: number
    /** 注册当天完成首充是否加码 0-否 1-是 */
    rewardAddingFlag?: boolean
    /** 奖励发放状态 -1-未完成任务 0-正在发放 1-已发放(系统已发放奖励，与用户是否领取无关) 2-已领取 */
    rewardGiftStatus?: number
    /** 目标类型 1-单笔 2-累计 */
    targetType?: number
    /** 任务描述 */
    taskDescriptions?: string
    /** 任务标题 */
    taskTitles?: string
    /** 任务类型：1-新手任务/2-体验任务/3-交易任务/4-每日任务/5-专属任务/6-充值交易挑战 */
    taskType?: number
    /** 交易金额 */
    tradeAmount?: string
  }[]
}>
export const getRewardTasksList = (params?: TGetRewardTasksListParams, options?: RequestOptions) => {
  return hcAxios.get<TGetRewardTasksListResponse>(API.RewardTasksList, { params, options })
}

export type TPostRewardMyRewardsUseParams = {
  /** 卡券id */
  cardId?: number
  /** 产品类型 2-现货 3-现货杠杆 4-永续合约 5-交割合约 6-期权 */
  instType?: number
}
export type TPostRewardMyRewardsUseResponse = TResponse<any>
export const postRewardMyRewardsUse = (params?: TPostRewardMyRewardsUseParams, options?: RequestOptions) => {
  return hcAxios.post<TPostRewardMyRewardsUseResponse>(API.RewardMyRewardsUse, params, { options })
}

export type TGetRewardMytasksAmountParams = {
  /** 福利中心版本 1-2023版本 2-202409版本 3-202503版本 */
  bver?: any
  /** 0-生效任务，1-新手任务 */
  taskType?: any

  userId?: any
}
export type TGetRewardMytasksAmountResponse = TResponse<string>
export const getRewardMytasksAmount = (params?: TGetRewardMytasksAmountParams, options?: RequestOptions) => {
  return hcAxios.get<TGetRewardMytasksAmountResponse>(API.RewardMytasksAmount, { params, options })
}

export type TGetRewardRandomCompletedtasksParams = any
export type TGetRewardRandomCompletedtasksResponse = TResponse<
  {
    /** 卡券类型：1-合约体验金/2-合约固定额度手续费抵扣券/3-合约固定比例手续费抵扣券/4-理财体验金/5-合约无门槛体验金 */
    cardType?: string
    /** 面额(体验金金额) */
    denomination?: number
    /** 比例：如折扣比例10%，返回10 */
    proportion?: number
    /** 任务类型：1-新手任务/2-体验任务/3-交易任务/4-每日任务/5-专属任务/6-充值交易挑战 */
    taskType?: number
    /** 名称 */
    userName?: string
  }[]
>
export const getRewardRandomCompletedtasks = (
  params?: TGetRewardRandomCompletedtasksParams,
  options?: RequestOptions
) => {
  return hcAxios.get<TGetRewardRandomCompletedtasksResponse>(API.RewardRandomCompletedtasks, { params, options })
}

export type TGetRewardTasksAmountParams = {
  /** 福利中心版本 1-2023版本 2-202409版本 3-202503版本 */
  bver?: any
  /** 0-生效任务，1-新手任务 */
  taskType?: any

  userId?: any
}
export type TGetRewardTasksAmountResponse = TResponse<string>
export const getRewardTasksAmount = (params?: TGetRewardTasksAmountParams, options?: RequestOptions) => {
  return hcAxios.get<TGetRewardTasksAmountResponse>(API.RewardTasksAmount, { params, options })
}

export type TGetRewardTasksDetailParams = {
  /** 任务ID */
  taskId?: any
}
export type TGetRewardTasksDetailResponse = TResponse<{
  /** 加码截止时间，注册时间+24小时 */
  addingEndTime?: number
  /** 卡券类型：1-合约体验金/2-合约固定额度手续费抵扣券/3-合约固定比例手续费抵扣券/4-理财体验金/5-合约无门槛体验金 */
  cardType?: number
  /** 合约交易对编码别名 例如：ETH/USDT */
  contractCodeAlias?: string
  /** 面额(体验金金额) */
  denomination?: string
  /** 体验金限制持仓时间(天) */
  holdingDays?: number
  /** 任务id */
  id?: number
  /** 最大支持杠杆 */
  maxMarginRatio?: number
  /** 我的任务id */
  myTaskId?: number
  /** 比例：如折扣比例10%，返回10 */
  proportion?: string
  /** 截止时间 */
  receiveEndTime?: number
  /** 领取状态 0-未领取，1-已领取，2-条件不符 */
  receiveStatus?: number
  /** 加码金额 */
  rewardAddingAmount?: number
  /** 注册当天完成首充是否加码 0-否 1-是 */
  rewardAddingFlag?: boolean
  /** 奖励发放状态 -1-未完成任务 0-正在发放 1-已发放(系统已发放奖励，与用户是否领取无关) 2-已领取 */
  rewardGiftStatus?: number
  /** 目标类型 1-单笔 2-累计 */
  targetType?: number
  /** 任务描述 */
  taskDescriptions?: string
  /** 任务标题 */
  taskTitles?: string
  /** 任务类型：1-新手任务/2-体验任务/3-交易任务/4-每日任务/5-专属任务/6-充值交易挑战 */
  taskType?: number
  /** 交易金额 */
  tradeAmount?: string
}>
export const getRewardTasksDetail = (params?: TGetRewardTasksDetailParams, options?: RequestOptions) => {
  return hcAxios.get<TGetRewardTasksDetailResponse>(API.RewardTasksDetail, { params, options })
}

export type TGetRewardFutureCardStatusParams = any
export type TGetRewardFutureCardStatusResponse = TResponse<{
  /** 图标显示状态：0-不显示/1-显示/2-显示及红点 */
  icoStatus?: number
}>
export const getRewardFutureCardStatus = (params?: TGetRewardFutureCardStatusParams, options?: RequestOptions) => {
  return hcAxios.get<TGetRewardFutureCardStatusResponse>(API.RewardFutureCardStatus, { params, options })
}

export type TGetV1RewardTasksAmountParams = {
  /** 0-生效任务，1-新手任务 */
  taskType?: any

  userId?: any
}
export type TGetV1RewardTasksAmountResponse = TResponse<{
  /** 结束日期 */
  endDate?: string
  /** 是否活动中 */
  inActivity?: boolean
  /** 活动地区 */
  regions?: string[]
  /** 开始日期 */
  startDate?: string
  /** 任务累计奖励 */
  tradeAmountInUsdt?: string
}>
export const getV1RewardTasksAmount = (params?: TGetV1RewardTasksAmountParams, options?: RequestOptions) => {
  return hcAxios.get<TGetV1RewardTasksAmountResponse>(API.V1RewardTasksAmount, { params, options })
}

export type TGetRewardDailyTasksParams = {
  /** 福利中心版本 1-2023版本 2-202409版本 3-202503版本 */
  bver?: any
}
export type TGetRewardDailyTasksResponse = TResponse<{
  /** 当前奖励 */
  currentReward?: string
  /** 新人福利待领取奖励 */
  newcomerRewards?: string
  /** 任务列表 */
  tasks?: {
    /** 卡券类型：1-合约体验金/2-合约固定额度手续费抵扣券/3-合约固定比例手续费抵扣券/4-理财体验金/5-合约无门槛体验金 */
    cardType?: number
    /** 每日任务：1-链上充值/2-现货/3-杠杆/4-合约/5-跟单/6-理财赚币/7-净资产/8-邀请好友 */
    chlgTaskType?: number
    /** 支持合约币对 */
    contractCode?: string
    /** 合约类型 perpetual-永续 week-当周 nextWeek-次周 quarter-当季 nextQuarter-次季 */
    contractType?: string
    /** 当前交易额 */
    currentTradeAmount?: string
    /** 截止时间 */
    deadlineTime?: number
    /** 面额 */
    denomination?: string
    /** 任务失效时间 */
    expireTime?: number
    /** 我的任务id */
    id?: number
    /** 产品类型 2-现货 3-现货杠杆 4-永续合约 5-交割合约 6-期权 */
    instType?: number
    /** 比例：如折扣比例10%，返回10 */
    proportion?: string
    /** 奖励发放状态 -1-未完成任务 0-正在发放 1-已发放(系统已发放奖励，与用户是否领取无关) 2-已领取 */
    rewardGiftStatus?: number
    /** 任务id */
    rewardTaskId?: number
    /** 目标交易额 */
    targetTradeAmount?: string
    /** 任务描述 */
    taskDescriptions?: string
    /** 任务状态：1-进行中/2-已完成/3-已过期 */
    taskStatus?: number
    /** 任务标题 */
    taskTitles?: string
    /** 任务类型：1-新手任务/2-体验任务/3-交易任务/4-每日任务/5-专属任务/6-充值交易挑战 */
    taskType?: number
    /** 是否限时 0-否 1-是 */
    tlimitedFlag?: boolean
    /** 交易产品 1-永续合约 2-现货交易 3-杠杆交易 */
    tradeInst?: number
    /** 完成时间戳 */
    updatedTime?: number
    /** 任务有效期(天)/-1表示无限期 */
    validityPeriod?: number
  }[]
  /** 总奖励 */
  totalReward?: string
}>
export const getRewardDailyTasks = (params?: TGetRewardDailyTasksParams, options?: RequestOptions) => {
  return hcAxios.get<TGetRewardDailyTasksResponse>(API.RewardDailyTasks, { params, options })
}

export type TGetRewardDpttradeTasksParams = {
  /** 福利中心版本 1-2023版本 2-202409版本 3-202503版本 */
  bver?: any
  /** 是否返回总记录数，默认true */
  count?: any
  /** 页码 */
  pageNum?: any
  /** 每页显示条数 */
  pageSize?: any
  /** 不传返回所有类型任务，1-新手任务/2-体验任务/3-交易任务/4-每日任务/5-专属任务/6-充值交易挑战 */
  taskType?: any
}
export type TGetRewardDpttradeTasksResponse = TResponse<{
  /** 新人充值交易挑战最高奖励金额USDT */
  dpttradeRewardAmount?: string
  /** 新人最高奖励金额USDT */
  newbieRewardAmount?: string
  /** 可领取奖励金额USDT */
  receivableRewardAmount?: string
  /** 截止时间 */
  receiveEndTime?: number
  /** 注册时间 */
  registerTime?: number
  /** 任务列表 */
  tasks?: {
    /** 活动状态 1-进行中(30天新人期内) 2-监控期(30天后的3天监控时期) 3-已结束(监控期过后) */
    activityStatus?: number
    /** 卡券类型：1-合约体验金/2-合约固定额度手续费抵扣券/3-合约固定比例手续费抵扣券/4-理财体验金/5-合约无门槛体验金 */
    cardType?: number
    /** 合约交易对编码别名 例如：ETH/USDT */
    contractCodeAlias?: string
    /** 面额(体验金金额) */
    denomination?: string
    /** 合约交易额USDT */
    futureTradeAmount?: string
    /** 档位编号 */
    ladder?: number
    /** 最大支持杠杆 */
    maxMarginRatio?: number
    /** 我的累计合约交易额USDT(新手期内) */
    myFutureTradeAmount?: string
    /** 我的净充值金额USDT(新手期内) */
    myNetdptAmount?: string
    /** 我的任务id */
    myTaskId?: number
    /** 净充值金额USDT */
    netdptAmount?: string
    /** 比例：如折扣比例10%，返回10 */
    proportion?: string
    /** 奖励发放状态 -1-未完成任务 0-正在发放 1-已发放(系统已发放奖励，与用户是否领取无关) 2-已领取 */
    rewardGiftStatus?: number
    /** 任务id */
    rewardTaskId?: number
  }[]
}>
export const getRewardDpttradeTasks = (params?: TGetRewardDpttradeTasksParams, options?: RequestOptions) => {
  return hcAxios.get<TGetRewardDpttradeTasksResponse>(API.RewardDpttradeTasks, { params, options })
}

export type TGetRewardMyTasksRecordParams = {
  /** 是否返回总记录数，默认true */
  count?: any
  /** 结束时间戳 */
  endTime?: any
  /** 页码 */
  pageNum?: any
  /** 每页显示条数 */
  pageSize?: any
  /** 开始时间戳 */
  startTime?: any
  /** 任务状态：1-进行中/2-已完成/3-已过期。不传查全部类型 */
  taskStatus?: any
  /** 不传返回所有类型任务，1-新手任务/4-每日任务/6-充值交易挑战 */
  taskType?: any
}
export type TGetRewardMyTasksRecordResponse = TResponse<
  {
    /** 卡券类型：1-合约体验金/2-合约固定额度手续费抵扣券/3-合约固定比例手续费抵扣券/4-理财体验金/5-合约无门槛体验金 */
    cardType?: number
    /** 每日任务：1-链上充值/2-现货/3-杠杆/4-合约/5-跟单/6-理财赚币/7-净资产/8-邀请好友 */
    chlgTaskType?: number
    /** 支持合约币对 */
    contractCode?: string
    /** 合约类型 perpetual-永续 week-当周 nextWeek-次周 quarter-当季 nextQuarter-次季 */
    contractType?: string
    /** 当前交易额 */
    currentTradeAmount?: string
    /** 截止时间 */
    deadlineTime?: number
    /** 面额 */
    denomination?: string
    /** 任务失效时间 */
    expireTime?: number
    /** 我的任务id */
    id?: number
    /** 产品类型 2-现货 3-现货杠杆 4-永续合约 5-交割合约 6-期权 */
    instType?: number
    /** 比例：如折扣比例10%，返回10 */
    proportion?: string
    /** 奖励发放状态 -1-未完成任务 0-正在发放 1-已发放(系统已发放奖励，与用户是否领取无关) 2-已领取 */
    rewardGiftStatus?: number
    /** 任务id */
    rewardTaskId?: number
    /** 目标交易额 */
    targetTradeAmount?: string
    /** 任务描述 */
    taskDescriptions?: string
    /** 任务状态：1-进行中/2-已完成/3-已过期 */
    taskStatus?: number
    /** 任务标题 */
    taskTitles?: string
    /** 任务类型：1-新手任务/2-体验任务/3-交易任务/4-每日任务/5-专属任务/6-充值交易挑战 */
    taskType?: number
    /** 是否限时 0-否 1-是 */
    tlimitedFlag?: boolean
    /** 交易产品 1-永续合约 2-现货交易 3-杠杆交易 */
    tradeInst?: number
    /** 完成时间戳 */
    updatedTime?: number
    /** 任务有效期(天)/-1表示无限期 */
    validityPeriod?: number
  }[]
>
export const getRewardMyTasksRecord = (params?: TGetRewardMyTasksRecordParams, options?: RequestOptions) => {
  return hcAxios.get<TGetRewardMyTasksRecordResponse>(API.RewardMyTasksRecord, { params, options })
}

export type TPostRewardReceiveMyRewardParams = {
  /** 安静模式：忽略错误 */
  quiet?: boolean
  /** 任务id */
  taskId?: number
}
export type TPostRewardReceiveMyRewardResponse = TResponse<any>
export const postRewardReceiveMyReward = (params?: TPostRewardReceiveMyRewardParams, options?: RequestOptions) => {
  return hcAxios.post<TPostRewardReceiveMyRewardResponse>(API.RewardReceiveMyReward, params, { options })
}

export type TPostRewardActivityApplyParams = {
  /** 活动id */
  activityId?: number
  /** 首充金额(USDT) */
  firstDepositAmount?: number
  /** 可领礼金(USDT) */
  receivableAmount?: number
}
export type TPostRewardActivityApplyResponse = TResponse<any>
export const postRewardActivityApply = (params?: TPostRewardActivityApplyParams, options?: RequestOptions) => {
  return hcAxios.post<TPostRewardActivityApplyResponse>(API.RewardActivityApply, params, { options })
}

export type TGetRewardDpttradeReleaseCardParams = {
  /** myTaskId */
  myTaskId?: any
  /** userId */
  userId?: any
}
export type TGetRewardDpttradeReleaseCardResponse = TResponse<any>
export const getRewardDpttradeReleaseCard = (
  params?: TGetRewardDpttradeReleaseCardParams,
  options?: RequestOptions
) => {
  return hcAxios.get<TGetRewardDpttradeReleaseCardResponse>(API.RewardDpttradeReleaseCard, { params, options })
}

export type TGetRewardBannerActivityListParams = any
export type TGetRewardBannerActivityListResponse = TResponse<
  {
    /** App图片 */
    appImage?: string
    /** App链接 */
    appLink?: string
    /** Web图片 */
    webImage?: string
    /** Web链接 */
    webLink?: string
  }[]
>
export const getRewardBannerActivityList = (params?: TGetRewardBannerActivityListParams, options?: RequestOptions) => {
  return hcAxios.get<TGetRewardBannerActivityListResponse>(API.RewardBannerActivityList, { params, options })
}

export type TGetRewardExclusiveTasksParams = {
  /** 福利中心版本 1-2023版本 2-202409版本 3-202503版本 */
  bver?: any
}
export type TGetRewardExclusiveTasksResponse = TResponse<{
  /** 新人福利待领取奖励 */
  newcomerRewards?: string
  /** 上级用户昵称 */
  parentNickName?: string
  /** 上级用户头像 */
  parentPhoto?: string
  /** 任务列表 */
  tasks?: {
    /** 卡券类型：1-合约体验金/2-合约固定额度手续费抵扣券/3-合约固定比例手续费抵扣券/4-理财体验金/5-合约无门槛体验金 */
    cardType?: number
    /** 每日任务：1-链上充值/2-现货/3-杠杆/4-合约/5-跟单/6-理财赚币/7-净资产/8-邀请好友 */
    chlgTaskType?: number
    /** 支持合约币对 */
    contractCode?: string
    /** 合约类型 perpetual-永续 week-当周 nextWeek-次周 quarter-当季 nextQuarter-次季 */
    contractType?: string
    /** 当前交易额 */
    currentTradeAmount?: string
    /** 截止时间 */
    deadlineTime?: number
    /** 面额 */
    denomination?: string
    /** 任务失效时间 */
    expireTime?: number
    /** 我的任务id */
    id?: number
    /** 产品类型 2-现货 3-现货杠杆 4-永续合约 5-交割合约 6-期权 */
    instType?: number
    /** 比例：如折扣比例10%，返回10 */
    proportion?: string
    /** 奖励发放状态 -1-未完成任务 0-正在发放 1-已发放(系统已发放奖励，与用户是否领取无关) 2-已领取 */
    rewardGiftStatus?: number
    /** 任务id */
    rewardTaskId?: number
    /** 目标交易额 */
    targetTradeAmount?: string
    /** 任务描述 */
    taskDescriptions?: string
    /** 任务状态：1-进行中/2-已完成/3-已过期 */
    taskStatus?: number
    /** 任务标题 */
    taskTitles?: string
    /** 任务类型：1-新手任务/2-体验任务/3-交易任务/4-每日任务/5-专属任务/6-充值交易挑战 */
    taskType?: number
    /** 是否限时 0-否 1-是 */
    tlimitedFlag?: boolean
    /** 交易产品 1-永续合约 2-现货交易 3-杠杆交易 */
    tradeInst?: number
    /** 完成时间戳 */
    updatedTime?: number
    /** 任务有效期(天)/-1表示无限期 */
    validityPeriod?: number
  }[]
  /** 用户昵称 */
  userNickName?: string
}>
export const getRewardExclusiveTasks = (params?: TGetRewardExclusiveTasksParams, options?: RequestOptions) => {
  return hcAxios.get<TGetRewardExclusiveTasksResponse>(API.RewardExclusiveTasks, { params, options })
}

export type TGetRewardActivityParamsParams = {
  /** 福利中心版本 1-2023版本 2-202409版本 3-202503版本 */
  bver?: any
  /** 0-生效任务，1-新手任务 */
  taskType?: any

  userId?: any
}
export type TGetRewardActivityParamsResponse = TResponse<{
  /** 用户是否代理商或旗下 0-否,1-是 */
  agentUser?: boolean
  /** 助力返现活动状态 1-开启 2-关闭(助力单进度失效) 3-关闭(助力单进度保留) */
  rebateStatus?: number
  /** 截止时间 */
  receiveEndTime?: number
  /** 注册时间 */
  registerTime?: number
  /** 新手任务累计奖励金额 */
  taskAmountInUsdt?: string
}>
export const getRewardActivityParams = (params?: TGetRewardActivityParamsParams, options?: RequestOptions) => {
  return hcAxios.get<TGetRewardActivityParamsResponse>(API.RewardActivityParams, { params, options })
}

export type TGetRewardExistAgentUserParams = any
export type TGetRewardExistAgentUserResponse = TResponse<boolean>
export const getRewardExistAgentUser = (params?: TGetRewardExistAgentUserParams, options?: RequestOptions) => {
  return hcAxios.get<TGetRewardExistAgentUserResponse>(API.RewardExistAgentUser, { params, options })
}

export type TPostRewardActivityFirstDepositStatusParams = {
  /** 活动id */
  activityId?: number
  /** 首充金额(USDT) */
  firstDepositAmount?: number
  /** 可领礼金(USDT) */
  receivableAmount?: number
}
export type TPostRewardActivityFirstDepositStatusResponse = TResponse<{
  /** 用户是否已报名 true-是 false-否 */
  applied?: boolean
  /** 首充金额(USDT) */
  firstDepositAmount?: string
  /** 可领礼金(USDT) */
  receivableAmount?: string
  /** 用户是否已领取 true-是 false-否 */
  received?: boolean
  /** 注册时间戳 */
  registerTime?: number
  /** 用户已领取的开仓券id */
  openTicketId?: number
  /** 用户是否已领取开仓券 */
  receivedOpenTicket?: boolean
}>
export const postRewardActivityFirstDepositStatus = (
  params?: TPostRewardActivityFirstDepositStatusParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostRewardActivityFirstDepositStatusResponse>(API.RewardActivityFirstDepositStatus, params, {
    options,
  })
}

export type TPostRewardActivityFirstDepositApplyParams = {
  /** 活动id */
  activityId?: number
  /** 首充金额(USDT) */
  firstDepositAmount?: number
  /** 可领礼金(USDT) */
  receivableAmount?: number
}
export type TPostRewardActivityFirstDepositApplyResponse = TResponse<{
  /** USDT币种ID */
  usdtCoinId?: number
  /** USDT(TRC20)币种ID */
  usdtTrc20Id?: number
}>
export const postRewardActivityFirstDepositApply = (
  params?: TPostRewardActivityFirstDepositApplyParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostRewardActivityFirstDepositApplyResponse>(API.RewardActivityFirstDepositApply, params, {
    options,
  })
}

export type TGetRewardActivityFirstDepositEventParams = {
  /** 活动标识 */
  event?: any

  userId?: any
}
export type TGetRewardActivityFirstDepositEventResponse = TResponse<{
  /** 活动ID */
  activityId?: number
  /** 活动是否可报名 true-是 false-否 */
  allowApply?: boolean
  /** 结束时间戳 */
  endTime?: number
  /** 首充活动奖励上限，默认4000 */
  firstdptMaxRewardAmount?: string
  /** 首充活动最小金额USDT */
  firstdptMinDptAmount?: string
  /** 首充活动奖励比例，默认40% */
  firstdptRewardRatio?: string
  /** 开始时间戳 */
  startTime?: number
  /** 是否为代理商旗下用户，true-是 false-否 */
  subordinate?: boolean
}>
export const getRewardActivityFirstDepositEvent = (
  params?: TGetRewardActivityFirstDepositEventParams,
  options?: RequestOptions
) => {
  return hcAxios.get<TGetRewardActivityFirstDepositEventResponse>(API.RewardActivityFirstDepositEvent, {
    params,
    options,
  })
}

export type TPostRewardActivityFirstDepositReceiveParams = {
  /** 活动id */
  activityId?: number
  /** 首充金额(USDT) */
  firstDepositAmount?: number
  /** 可领礼金(USDT) */
  receivableAmount?: number
}
export type TPostRewardActivityFirstDepositReceiveResponse = TResponse<any>
export const postRewardActivityFirstDepositReceive = (
  params?: TPostRewardActivityFirstDepositReceiveParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostRewardActivityFirstDepositReceiveResponse>(API.RewardActivityFirstDepositReceive, params, {
    options,
  })
}
